import { Link } from "react-router-dom";
import { Home, CalendarDays, Users, Map, User } from "lucide-react";
import { useT } from "../lib/i18n";

/**
 * Shared bottom navigation for the private guest portal.
 * Calendar + People are first-class destinations (most-used guest actions).
 */
const PortalBottomNav = ({ active = null }) => {
  const { t, isDe } = useT();
  const items = [
    { id: "home", icon: Home, label: t("Home"), path: "/dashboard" },
    { id: "calendar", icon: CalendarDays, label: isDe ? "Kalender" : "Calendar", path: "/community?tab=activities" },
    { id: "people", icon: Users, label: t("People"), path: "/community?tab=members" },
    { id: "guide", icon: Map, label: t("Guide"), path: "/guide" },
    { id: "profile", icon: User, label: t("Profile"), path: "/dashboard?tab=profile" },
  ];

  return (
    <nav className="bottom-nav" data-testid="portal-bottom-nav">
      <div className="max-w-2xl mx-auto px-3 pt-1.5 pb-2 grid grid-cols-5">
        {items.map(({ id, icon: Icon, label, path }) => {
          const isActive = active === id;
          return (
            <Link
              key={id}
              to={path}
              className={`relative flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition-colors active:scale-[0.94] ${
                isActive ? "text-[#C85A38]" : "text-[#1A1A1A]/45 hover:text-[#C85A38]"
              }`}
              data-testid={`nav-${id}`}
            >
              <Icon className="w-[22px] h-[22px]" strokeWidth={isActive ? 2 : 1.6} />
              <span className={`text-[10px] ${isActive ? "font-semibold" : "font-medium"}`}>{label}</span>
              {isActive && <span className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#C85A38]" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default PortalBottomNav;
